import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { datadogRum } from '@datadog/browser-rum';

import { createRumBeforeSend } from '@ninety/platform/services/vendor/datadog';
import { environment } from '@ninety/ui/web/environments';

import { AppModule } from './app/app.module';

// Initialize Datadog RUM
datadogRum.init({
  applicationId: environment.dataDogRumApplicationId,
  clientToken: environment.dataDogClientToken,
  site: 'datadoghq.com',
  service: environment.service,
  env: environment.env,
  version: environment.ninetyReleaseVersion ?? environment.appVersion,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 0,
  defaultPrivacyLevel: 'mask-user-input',
  // v6+ defaults these to true; pinned explicitly so future SDK default changes don't silently alter what we collect
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  // Drops marketing CSP violations, extension-only errors, and repeat "Script error." (DEV-28546)
  beforeSend: createRumBeforeSend({ appOrigin: window.location.origin }),
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] });
/*.catch(error =>
    console.error(error.message, {
      error,
      env: `${environment.env}:${environment.region}`,
      isLocal: environment.hostedEnvironment === 'localhost',
      service: environment.service,
      version: environment.appVersion,
    })
  );*/
